module.exports = __webpack_public_path__ + "img/LINEAPP.c00a0760.png";